/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_Mixed_MediaInputs */

const en_val_mixed_media = /** @type {(inputs: Val_Mixed_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mixed Media`)
};

const es_val_mixed_media = /** @type {(inputs: Val_Mixed_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Técnica mixta`)
};

const fr_val_mixed_media = /** @type {(inputs: Val_Mixed_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Techniques mixtes`)
};

const de_val_mixed_media = /** @type {(inputs: Val_Mixed_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mixed Media`)
};

const ja_val_mixed_media = /** @type {(inputs: Val_Mixed_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ミックスドメディア`)
};

const zh_val_mixed_media = /** @type {(inputs: Val_Mixed_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`综合媒介`)
};

const ar_val_mixed_media = /** @type {(inputs: Val_Mixed_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وسائط متعددة`)
};

const id_val_mixed_media = /** @type {(inputs: Val_Mixed_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media Campuran`)
};

const it_val_mixed_media = /** @type {(inputs: Val_Mixed_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tecnica Mista`)
};

const ru_val_mixed_media = /** @type {(inputs: Val_Mixed_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Смешанная техника`)
};

const pt_val_mixed_media = /** @type {(inputs: Val_Mixed_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mídia Mista`)
};

const ko_val_mixed_media = /** @type {(inputs: Val_Mixed_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`혼합 매체`)
};

/**
* | output |
* | --- |
* | "Mixed Media" |
*
* @param {Val_Mixed_MediaInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_mixed_media = /** @type {((inputs?: Val_Mixed_MediaInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_Mixed_MediaInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_mixed_media(inputs)
	if (locale === "es") return es_val_mixed_media(inputs)
	if (locale === "fr") return fr_val_mixed_media(inputs)
	if (locale === "de") return de_val_mixed_media(inputs)
	if (locale === "ja") return ja_val_mixed_media(inputs)
	if (locale === "zh") return zh_val_mixed_media(inputs)
	if (locale === "ar") return ar_val_mixed_media(inputs)
	if (locale === "id") return id_val_mixed_media(inputs)
	if (locale === "it") return it_val_mixed_media(inputs)
	if (locale === "ru") return ru_val_mixed_media(inputs)
	if (locale === "pt") return pt_val_mixed_media(inputs)
	return ko_val_mixed_media(inputs)
});